import {AutoplayViewMobileLandscape} from '@gongxigames/framework/slot/modules/autoplay/AutoplayViewMobileLandscape';
import {KeypadViewMobilePortrait} from '@gongxigames/framework/slot/modules/keypad/KeypadViewMobilePortrait';
import {KeypadView} from '@gongxigames/framework/slot/modules/keypad/KeypadView';
import {Sprite} from 'pixi.js';
import {LAYERS} from '@gongxigames/framework/slot/configs/Layers';
import {DeviceType} from '@gongxigames/framework/core';

export class AutoplayViewMobilePortrait extends AutoplayViewMobileLandscape {
    public static readonly NAME: symbol = Symbol('AutoplayViewMobilePortrait');
    public static layer = LAYERS.KEYPAD;
    public static platform: DeviceType = DeviceType.MOBILE;

    protected get mainSprite(): Sprite {
        return this._installer.getComponent<KeypadView>(KeypadViewMobilePortrait.NAME).mainSprite;
    }

    public getViewDependencies(): (symbol|string)[] {
        return [KeypadViewMobilePortrait.NAME];
    }
}
